import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BannerImage from "../assets/background.jpg";
import ImageCarousel from "../components/ImageCarousel";
import Partner1 from "../assets/partner-1.jpg";
import Partner2 from "../assets/partner-2.jpg";
import Partner3 from "../assets/partner-3.jpg";
import Partner4 from "../assets/partner-4.jpg";
import Partner5 from "../assets/partner-5.jpg";
import Partner6 from "../assets/partner-6.jpg";
import Partner7 from "../assets/partner-7.jpg";
import Partner8 from "../assets/partner-8.jpg";
import Partner9 from "../assets/partner-9.jpg";
import "../styles/Home.css";

function Home() {
  const customerReviews = [
    {
      id: 1,
      name: "Rajesh Kumar",
      location: "Delhi",
      review: "Exceptional work on our bedroom ceiling! The false ceiling design completely transformed our space. The team was professional, punctual, and delivered exactly what we envisioned. Highly recommend Get Karigar!",
      service: "False Ceiling"
    },
    {
      id: 2,
      name: "Priya Sharma",
      location: "Ghaziabad",
      review: "Amazing wall painting service! They helped us choose the perfect color combination for our living room. The finish is flawless and the attention to detail is remarkable. Worth every penny!",
      service: "Wall Painting"
    },
    {
      id: 3,
      name: "Amit Gupta",
      location: "Noida",
      review: "Great experience with office interior work. The team completed the project on time and within budget. The quality of work exceeded our expectations. Will definitely hire them again for future projects.",
      service: "Office Interior"
    }
  ];

  const faqData = [
    {
      id: 1,
      question: "What sets GetKarigar apart?",
      answer: "Design-first approach, transparent pricing, verified experts, and on-time delivery with hassle-free execution."
    },
    {
      id: 2,
      question: "How much does a false ceiling cost?",
      answer: "Costs depend on material, design, and area. Gypsum ceilings typically fall in a moderate range; PVC can be budget-friendly; wooden & designer ceilings are premium. Get an on-site quote for accurate pricing."
    },
    {
      id: 3,
      question: "How do I maintain a false ceiling?",
      answer: "Dry dusting and occasional damp wiping. Avoid harsh chemicals. Inspect for moisture seepage annually."
    },
    {
      id: 4,
      question: "Do you do commercial projects?",
      answer: "Yes—offices, showrooms, restaurants, banquet halls, retail, and educational spaces."
    }
  ];

  const partners = [
    { id: 1, logo: Partner1, name: "Partner 1" },
    { id: 2, logo: Partner2, name: "Partner 2" },
    { id: 3, logo: Partner3, name: "Partner 3" },
    { id: 4, logo: Partner4, name: "Partner 4" },
    { id: 5, logo: Partner5, name: "Partner 5" },
    { id: 6, logo: Partner6, name: "Partner 6" },
    { id: 7, logo: Partner7, name: "Partner 7" },
    { id: 8, logo: Partner8, name: "Partner 8" },
    { id: 9, logo: Partner9, name: "Partner 9" }
  ];

  const carouselRef = useRef(null);
  const [currentTransform, setCurrentTransform] = useState(0);
  const [isUserInteracting, setIsUserInteracting] = useState(false);

  useEffect(() => {
    const autoScroll = () => {
      if (!isUserInteracting) {
        setCurrentTransform(prev => {
          const itemWidth = 240; // Width of each partner item including margin
          const totalWidth = partners.length * itemWidth;
          const newTransform = prev - itemWidth;
          
          // If we've moved past the first set, seamlessly continue with duplicates
          // The duplicates are already rendered so this creates smooth infinite scroll
          if (Math.abs(newTransform) >= totalWidth) {
            // Reset position to create seamless loop
            return 0;
          }
          
          return newTransform;
        });
      }
    };

    const interval = setInterval(autoScroll, 2000); // Auto-scroll every 2 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [partners.length, isUserInteracting]);

  const handleMouseDown = (e) => {
    setIsUserInteracting(true);
    const startX = e.pageX || e.touches?.[0]?.pageX;
    const startTransform = currentTransform;

    const handleMouseMove = (e) => {
      const currentX = e.pageX || e.touches?.[0]?.pageX;
      const diff = currentX - startX;
      const newTransform = startTransform + diff;
      
      // Allow smooth dragging with boundaries
      const itemWidth = 240;
      const totalWidth = partners.length * itemWidth;
      
      // Keep within bounds for smooth experience
      if (newTransform > itemWidth) {
        setCurrentTransform(-totalWidth + (newTransform - itemWidth));
      } else if (newTransform < -totalWidth - itemWidth) {
        setCurrentTransform(newTransform + totalWidth);
      } else {
        setCurrentTransform(newTransform);
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleMouseMove);
      document.removeEventListener('touchend', handleMouseUp);
      
      // Resume auto-scroll after 3 seconds of no interaction
      setTimeout(() => {
        setIsUserInteracting(false);
      }, 3000);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchmove', handleMouseMove);
    document.addEventListener('touchend', handleMouseUp);
  };

  return (
    <div className="home-page">
      <div className="home" style={{ backgroundImage: `url(${BannerImage})` }}>
        <div className="headerContainer">
          <h1> Get Karigar </h1>
          <p> Where Walls and Ceilings Come to Life </p>
          <a 
            href="https://wa.me/919125691256?text=Hi%20Get%20Karigar,%20I%20would%20like%20to%20inquire%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-official-button"
          >
            <svg className="whatsapp-icon" viewBox="0 0 24 24" width="24" height="24" fill="#25D366">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
            </svg>
            Contact us on WhatsApp
          </a>
        </div>
        
        {/* Process Steps Section */}
        <div className="hero-process-section">
          <h2 className="process-title">Get your project done in 3 easy steps</h2>
          
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
              </svg>
            </div>
            <div className="step-content">
              <h3>1. BOOK A CONSULTATION</h3>
              <p>Share your requirements and get a free quote from our expert team for your dream project.</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
              </svg>
            </div>
            <div className="step-content">
              <h3>2. CONFIRM BOOKING</h3>
              <p>Approve the design and pricing. Our team will schedule the work at your convenience.</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-icon">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
                <path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"/>
              </svg>
            </div>
            <div className="step-content">
              <h3>3. WE'LL COMPLETE IT</h3>
              <p>Sit back and relax while our skilled karigars transform your space with quality work.</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Statistics Section */}
      <div className="statistics-section">
        <div className="statistics-container">
          <div className="stat-item">
            <div className="stat-number">12+</div>
            <div className="stat-label">Years of Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">18000+</div>
            <div className="stat-label">Happy Customers</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">200+</div>
            <div className="stat-label">Karigars</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">700+</div>
            <div className="stat-label">Projects</div>
          </div>
        </div>
      </div>
      
      {/* Partners Section */}
      <div className="partners-section">
        <div className="partners-container">
          <h2 className="section-heading">Our Trusted Partners</h2>
          <div className="partners-carousel">
            <div 
              className="partners-track" 
              ref={carouselRef}
              style={{
                transform: `translateX(${currentTransform}px)`,
                transition: isUserInteracting ? 'none' : 'transform 0.5s ease-in-out'
              }}
              onMouseDown={handleMouseDown}
              onTouchStart={handleMouseDown}
            >
              {/* First set of partners */}
              {partners.map((partner) => (
                <div key={partner.id} className="partner-item">
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    className="partner-logo"
                    draggable={false}
                  />
                </div>
              ))}
              {/* Duplicate set for seamless loop */}
              {partners.map((partner) => (
                <div key={`duplicate-${partner.id}`} className="partner-item">
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    className="partner-logo"
                    draggable={false}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Quote Section */}
      <div className="quote-section">
        <div className="quote-container">
          <h2 className="quote-text">We listen. We design. We deliver.</h2>
        </div>
      </div>
      
      <ImageCarousel />
      
      {/* Customer Reviews Section */}
      <div className="customer-reviews-section">
        <div className="reviews-container">
          <h2 className="section-heading">What Our Customers Say</h2>
          <p className="section-subtitle">Real experiences from real customers</p>
          
          <div className="reviews-grid">
            {customerReviews.map((review) => (
              <div key={review.id} className="review-card">
                <div className="review-header">
                  <div className="customer-info">
                    <h4 className="customer-name">{review.name}</h4>
                    <p className="customer-location">{review.location}</p>
                  </div>
                </div>
                <p className="review-text">"{review.review}"</p>
                <div className="service-tag">
                  <span className="service-label">{review.service}</span>
                </div>
              </div>
            ))}
          </div>
          
          <div className="more-reviews-indicator">
            <p className="more-reviews-text">... and many more satisfied customers!</p>
          </div>
        </div>
      </div>
      
      {/* FAQ Section */}
      <div className="faq-section">
        <div className="faq-container">
          <div className="faq-header">
            <h2 className="section-heading">Frequently Asked Questions</h2>
            <p className="faq-email">Need more help? Contact us at <a href="tel:+91-9125691256">+91-9125691256</a></p>
          </div>
          
          <div className="faq-grid">
            {faqData.map((faq) => (
              <div key={faq.id} className="faq-item">
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Contact Us Section */}
      <div className="contact-us-section">
        <div className="contact-us-container">
          <div className="contact-header">
            <h2 className="section-heading">Start Your Journey with Us</h2>
            <p className="contact-quote">"Your satisfaction is our priority. We're here to help you every step of the way."</p>
          </div>
          
          <div className="contact-info-grid">
            <div className="whatsapp-button-container">
              <a 
                href="https://wa.me/919125691256?text=Hi%20Get%20Karigar,%20I%20would%20like%20to%20inquire%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-official-button-contact"
              >
                <svg className="whatsapp-button-icon" viewBox="0 0 24 24" width="24" height="24" fill="#25D366">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
                Start WhatsApp Chat
              </a>
            </div>
            
            <div className="secondary-contact-row">
              <div className="contact-info-item">
                <h3 className="contact-info-title">📞 Call Us</h3>
                <p className="contact-info-text">+91-9125691256</p>
              </div>
              
              <div className="contact-info-item">
                <h3 className="contact-info-title">📍 Address</h3>
                <p className="contact-info-text">453-454, 4th Floor, JMD Megapolis, Sohna Road, Sector 48, Gurgaon, Haryana-122018</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
